/**
 * phase-compiler-chrome-batch item 4 — THE adjacent-swap used by every
 * placement move-up/move-down control (the Workspace card arrows and the CTD
 * tree's inline arrows). Extracted from DocumentList's private `swapDocs` so
 * the two surfaces cannot drift: one evaluator, every consumer calls it.
 *
 * Returns the SAME array reference when the move is a no-op (unknown id, or
 * at a section boundary) so callers can cheaply skip the API call.
 */
export function swapAdjacent<T extends { readonly Id: string }>(
  docs: readonly T[],
  docId: string,
  direction: 'up' | 'down',
): readonly T[] {
  const idx = docs.findIndex((d) => d.Id === docId);
  const swapWith = direction === 'up' ? idx - 1 : idx + 1;
  if (idx === -1 || swapWith < 0 || swapWith >= docs.length) return docs;
  const next = [...docs];
  [next[idx], next[swapWith]] = [next[swapWith]!, next[idx]!];
  return next;
}
